import { LOCALIZATION_MODE_COOKIE_NAME } from '@concur/core-ui-shell/lib/utils/localizationMode';
import Cookies from 'universal-cookie';

const clearLocalizationMode = () => {
    const cookies = new Cookies();
    cookies?.remove(LOCALIZATION_MODE_COOKIE_NAME, { path: '/' });
};
export default clearLocalizationMode;
